module.exports = {"previous":"Rov mus rau qhov ua ntej (previous)","next":"ntxiv mus"};